document.addEventListener("DOMContentLoaded", function(event) {
    const accTitles = document.getElementsByClassName("accordion-block__title");
    const accTexts = document.getElementsByClassName('accordion-block__text');

    function closeAllAccordions() {
        for (let i = 0; i < accTitles.length; i++) {
            accTitles[i].classList.remove('active');
            accTexts[i].classList.remove('show');
        }
    }

    function openAccordion(index) {
        accTitles[index].classList.add('active');
        accTexts[index].classList.add('show');
    }

    for (let i = 0; i < accTitles.length; i++) {
        accTitles[i].addEventListener('click', function() {
            if (this.classList.contains('active')) {
                closeAllAccordions();
            } else {
                closeAllAccordions();
                openAccordion(i);
            }
        });
    }

    // Open the first accordion by default
    if (accTitles.length > 0) {
        openAccordion(0);
    }
});